import React from 'react';
import PropTypes from 'prop-types';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { ConsumerReviewsEntities } from 'client/data/models/consumer-reviews';
import { VehicleModule } from 'site-modules/write-review/components/vehicle-module/vehicle-module';
import { SubmitButton } from 'site-modules/write-review/components/submit-button/submit-button';
import { VehicleReview } from './vehicle-review';
import { VehicleDetails } from './vehicle-details';

export function VehicleReviewAndDetails({
  reviewData = null,
  vehicle,
  validationErrors,
  fieldRef,
  validate,
  onSubmit,
}) {
  return (
    <div className="vehicle-review-and-details-step">
      <h1 className="heading-2 mb-1_5">Write a Review</h1>
      <VehicleModule vehicle={vehicle} showChangeButton={!reviewData} />
      <VehicleReview
        validate={validate}
        fieldRef={fieldRef}
        validationErrors={validationErrors}
        reviewData={reviewData}
      />
      <VehicleDetails
        validate={validate}
        fieldRef={fieldRef}
        validationErrors={validationErrors}
        reviewData={reviewData}
      />
      <SubmitButton
        onClick={onSubmit}
        validate={validate}
        isUpdateForm={!!reviewData}
        dataTrackingId="wr_submit_step_1"
      />
    </div>
  );
}

VehicleReviewAndDetails.propTypes = {
  vehicle: VehicleEntities.MakeModelSubmodelYear.isRequired,
  onSubmit: PropTypes.func.isRequired,
  fieldRef: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,
  validationErrors: PropTypes.shape({}).isRequired,
  reviewData: ConsumerReviewsEntities.ReviewData,
};
